<template>
    <div style="width: 150px;">
        <span class="font-color-btns">
            <template v-for="(hex, i) in hexCodes">
                <b-btn :key="`color_${i}`" :style="`background-color: ${hex}`" @click="$emit('save', hex)"></b-btn>
            </template>
        </span>
        <b-input-group>
            <b-form-input placeholder="#29AE43" v-model="customColor"></b-form-input>
            <b-input-group-append>
                <b-btn variant="primary" @click="$emit('save', customColor)">
                    <font-awesome-icon :icon="['fas', 'angle-right']" />
                </b-btn>
            </b-input-group-append>
        </b-input-group>
    </div>
</template>

<script>
export default {
    name: "ColorPicker",
    data: () => ({
        customColor: null,
    }),
    computed: {
        hexCodes: () => [
            '#f44336', '#e91e63', '#9c27b0', '#673ab7',
            '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4',
            '#009688', '#4caf50', '#8bc34a', '#cddc39',
            '#ffeb3b', '#ffc107', '#ff9800', '#ff5722',
            '#000000', '#FFFFFF'
        ]
    }
}
</script>

<style scoped>
.font-color-btns button {
    width: 25px;
    height: 25px;
}
button {
    border-radius: 0;
}
</style>